// Cash Casino — frontend GameModule. Dark-launch: games.is_locked=1.
import type { GameModule } from '../types';
import Page from './Page';

const casino: GameModule = {
  id: 'casino',
  displayName: 'Cash Casino',
  tag: 'Casino',
  theme: { gradient: 'from-yellow-400 to-red-700', emoji: '🎰', logo: '/games/casino/Logo.png' },
  orientation: 'portrait',
  adminIcon: 'casino',
  adminTheme: {
    headerFrom: 'from-zinc-900', headerTo: 'to-yellow-700',
    ring: 'ring-yellow-400', accent: 'bg-yellow-600', accentHover: 'hover:bg-yellow-500',
    dot: 'bg-yellow-400', softBg: 'bg-yellow-900/30', rangeAccent: 'accent-yellow-500',
    badgeClasses: 'bg-yellow-600/20 text-yellow-300 border-yellow-600/30',
  },
  Page,
};

export default casino;
